export default __webpack_public_path__ + "static/europe-000e3da9203d50ebf0c599d2406b5db1.webp";